export const createEmptyRowSelection = () => ({ type: 'include', ids: new Set() });

export const createRowSelectionFromIds = (ids) => ({
  type: 'include',
  ids: new Set(ids ?? []),
});

export const getSelectedRowIds = (selection) => {
  if (!selection) return [];
  if (Array.isArray(selection)) return selection;
  if (selection.type === 'include' && selection.ids instanceof Set) {
    return Array.from(selection.ids);
  }
  return [];
};

export const isRowSelected = (selection, rowId) =>
  getSelectedRowIds(selection).some((id) => String(id) === String(rowId));

export const hasSelectedRows = (selection) => getSelectedRowIds(selection).length > 0;

export const toGridRowSelectionModel = (selection) => {
  if (!selection) return createEmptyRowSelection();
  if (selection.type && selection.ids instanceof Set) return selection;
  if (Array.isArray(selection)) return createRowSelectionFromIds(selection);
  return createEmptyRowSelection();
};
